<app-progress-bar></app-progress-bar>
<div class="loading-shade-full" style="background:rgba(0, 0, 0, 0.3) !important;" *ngIf="(progressBarService._visible|async)">
  <mat-spinner *ngIf="(progressBarService._visible|async)">
  </mat-spinner>
</div>

<router-outlet></router-outlet>
